import React, { useState, useEffect } from "react";
import Navbar from "../widgets/Navbar";
import PartnerSidebar from "../widgets/PartnerSidebar";
import { useTranslation } from "react-i18next";
import { useGetUserReferListQuery } from "../../redux/accountApi";
import moment from "moment";

const PartnerReferal = () => {
  const { t } = useTranslation();
  const { data: userListRefer } = useGetUserReferListQuery();
  const [userReferList, setUserReferList] = useState([]);

  useEffect(() => {
    if (userListRefer) {
      setUserReferList(userListRefer);
    }
  }, [userListRefer]);

  const showTableHtmlRefer = () => {
    if (userReferList.length > 0) {
      return userReferList.map((item, index) => {
        return (
          <tr key={index}>
            <td>{index + 1}</td>
            <td>{item.email ? item.email : "-"}</td>
            <td>{item.mobile ? item.mobile : "-"}</td>
            <td>{moment(item.created_at).format("lll")}</td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td colSpan="4" className="text-center">
            {t("No Data Found")}
          </td>
        </tr>
      );
    }
  };

  return (
    <div>
       <Navbar />
      <section className="p70  pt-md-5 pb-md-5">
        <div className="container ">
          <div className="row ">
        <PartnerSidebar />
        <div className="col-xl-9 col-lg-8">
        <h5 className="mb-3">{t("Referral List")}</h5>
        <div className="row">
          <div className="col-md-12">
            <div className="p-3 p-md-4 bg2 br10 h_100">
              <div className="table-responsive trade_scrool_table">
                <table className="table table-striped mb-0 ">
                  <thead>
                    <tr>
                      <th>{t("Sr. No.")}</th>
                      <th>{t("Email")}</th>
                      <th>{t("Mobile No.")} </th>
                      <th>{t("Date")}</th>
                    </tr>
                  </thead>
                  <tbody>{showTableHtmlRefer()}</tbody>
                </table>
              </div>
            </div>
            </div>
            </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PartnerReferal;
